import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSummaryData } from '../../hooks/useSummaryData';
import {
  bot_tunnel_configurations,
  bot_tunnel_configurations_all,
} from '../../helpers/data/bot';
import type { IState } from '../../../../models';

import { useBotData } from '../useBotContext';

import SummarySection from './summary-section';
import Tooltip from '../atom/Tooltip';

import './styles.scss';

const BotSummaryPanel: FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  const data = useBotData();
  const params = useSelector((state: IState) => state.ahu.ahu_params);
  const fanParams = useSelector((state: IState) => state.fan.fan_params);
  const { coil_params, conn_hands } = useSelector(
    (state: IState) => state.coil,
  );
  const filterParams = useSelector(
    (state: IState) => state.filter.filter_params,
  );

  const sections = useSummaryData({
    data,
    params,
    fanParams,
    coil_params,
    conn_hands,
    filterParams,
    bot_tunnel_configurations,
    bot_tunnel_configurations_all,
  });

  const handleToggle = () => setIsOpen((prev) => !prev);

  return (
    <div className={`bot-summary ${isOpen ? 'is-open' : ''}`}>
      <button
        type="button"
        className="bot-summary__toggle w-100"
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Close summary panel' : 'Open summary panel'}
      >
        <span
          className={`bot-summary__chevron ${isOpen ? 'icon-chevron-right' : 'icon-chevron-left'}`}
          aria-hidden
        />
        <Tooltip title={isOpen ? '' : 'Input Summary'}>
          <span className="material-symbols-outlined" aria-hidden="true">
            &#xe8fe;
          </span>
        </Tooltip>
      </button>
      <div className="bot-summary__content">
        <div className="bot-summary__title">Input Summary</div>
        <div className="bot-summary__sections">
          {sections.map((sec, i) => (
            <SummarySection key={sec.title + i} {...sec} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BotSummaryPanel;
